export default __webpack_public_path__ + "e2e61b45cdd49b2a96817c9e39646d7d.png";